import { useMemo } from 'react';

/**
 * Generate spring animation configs.
 * @param configs overridable configs.
 */
export const useBottomSheetSpringConfigs = configs => {
  return useMemo(() => configs, [configs]);
};
//# sourceMappingURL=useBottomSheetSpringConfigs.js.map